// extracted by mini-css-extract-plugin
export default {"posts":"posts_posts__AGKIg"};